module.exports = __webpack_public_path__ + "img/creator-h5.94c6711f.webp";